import { useState } from "react";
import { useApi } from "utils";
import { InvoiceItem, DateGroup } from "../types/listTypes";
import { SuccessFetch } from "types";
import { mappingListInvoice } from "./mappingList";
// import moment from "moment";

export function useList() {
    const api = useApi();
  
    const [data, setData] = useState<DateGroup[] | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
  
    const fetchData = ({ start_date, end_date }: { start_date: string; end_date: string }) => {
      setLoading(true);
      api
        .get(`sales_analyze_period/get_data_sales_analyse`, {
          params: { start_date, end_date },
        })
        .then((res: SuccessFetch<{ payload: InvoiceItem[] }>) => {
            const newData = mappingListInvoice(res.data.payload);
            setData(newData);
        })
        .catch(() => {
          setData(null);
        })
        .finally(() => {
          setLoading(false);
        });
    };
  
    return { fetchData, data, loading };
  }